export default __webpack_public_path__ + "assets/static/data/spyne-docs-data.29220d9b0b5abff531895558df3c02bc.json";